export const MEDICAL_DEVICE_LIST_DEFAULT_SORT = {
  sortedColumn: 'patientLastName',
  sortedColumnOrder: 'ascend'
}
